const PagesData = {
  Map: {
    id: "CustomerLocation",
    title: "نقطه مکانی مشتریان",
    url: "/CustomerLocation",
    icon: [<i className="fa-solid fa-location-dot" />],
  },
  Maketerlocation: {
    id: "Maketerlocation",
    title: "نقطه مکانی بازاریاب",
    url: "/Maketerlocation",
    icon: [<i className="fa-solid fa-location-crosshairs" />],
  },
  // Product: {
  //   id: "itemsCatalog",
  //   title: "کاتالوگ کالا",
  //   url: "/itemsCatalog",
  //   icon: [<i className="fa-solid fa-book-open" />],
  // },
  // AccountBalance: {
  //   id: "accountBalance",
  //   title: "مانده حساب ها",
  //   url: "/accountBalance",
  //   icon: [<i className="fa-regular fa-clipboard" />],
  // },
  Home: [
    {
      id: "home",
      title: "خانه",
      url: "/home",
      icon: [<i className="fa fa-home" />],
    },
    // {
    //   id: "request",
    //   title: "ثبت درخواست",
    //   url: "/request",
    //   icon: [<i className="fa fa-cart-shopping" />],
    // },
    // {
    //   id: "payment",
    //   title: "ثبت پرداخت",
    //   url: "/payment",
    //   icon: [<i className="fa-solid fa-money-bill" />],
    // },
    {
      id: "addCustomer",
      title: "ثبت مشتری",
      url: "/addCustomer",
      icon: [<i className="fa-solid fa-user-plus" />],
    },
    {
      id: "requestHistory",
      title: "لیست درخواست ها",
      url: "/requestHistory",
      icon: [<i className="fa fa-clock-rotate-left" />],
    },
    {
      id: "salesAnalysis",
      title: "تحلیل فروش",
      url: "/salesAnalysis",
      icon: [<i className="fa-solid fa-chart-line" />],
    },
    // {
    //   id: "prizes",
    //   title: "جوایز کالایی",
    //   url: "/prizes",
    //   icon: [<i className="fa-solid fa-trophy" />],
    // },
    {
      id: "accountBalance",
      title: "مانده حساب ها",
      url: "/accountBalance",
      icon: [<i className="fa fa-coins" />],
    }
    // {
    //   id:"settings",
    //   title:"تنظیمات",
    //   url:"/settings",
    //   icon:[<i className="fa-solid fa-gears"/>]
    // }
  ],
};

export default PagesData;
